/**
 * The topology the user last looked at, remembered between visits.
 *
 * Keyed per user: the page is behind a login, and a shared machine must not hand one operator's
 * choice to the next one to sign in.
 *
 * Every storage failure is swallowed. A browser with storage disabled, full, or blocked by a
 * privacy mode still has a working page — it just opens on the first topology, which is exactly
 * what it did before anything was remembered at all.
 */

const KEY_PREFIX = 'vigimare.cyber.topology';

function keyFor(userId: string): string {
  return `${KEY_PREFIX}.${userId}`;
}

/** The id last selected by this user, or null when there is nothing usable to go back to. */
export function rememberedTopologyId(userId: string): number | null {
  try {
    const raw = localStorage.getItem(keyFor(userId));
    if (raw === null || raw.trim() === '') return null;

    const id = Number(raw);
    // A hint, not a source of truth: anything unreadable simply means "no preference".
    return Number.isInteger(id) ? id : null;
  } catch {
    return null;
  }
}

export function rememberTopologyId(userId: string, id: number): void {
  try {
    localStorage.setItem(keyFor(userId), String(id));
  } catch {
    // Nothing to do and nothing worth telling the user: the page works either way.
  }
}
